/// <amd-module name="Wiki/Renderer/VCUrlHelper" />
import { IVssPageContext } from "VSS/Platform/Context";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";
import { GitVersionDescriptor } from "Wiki/Clients/VC/Contracts/Git";
import { AttachSvgFileFF } from "Wiki/ViewCommon/Constants";
import { routeUrlFromRouteTemplate } from "Wiki/ViewCommon/Utils/WikiHelper";

const GIT_ITEMS_API_VERSION = "5.0-preview.1";

/**
 * Get the URL for displaying/downloading file content using the Items REST API.
 * Automatically resolves Git LFS pointers to content from LFS.
 * @param contentOnly if true and has a safe content-type, content will be displayed in the browser, else it is downloaded
 * @param includeContentMetadata if true, corresponding query parameter will be added to the URL; this makes server detect charset for text files
 */
export function getGitFileContentUrl(
    pageContext: IVssPageContext,
    projectId: string,
    repositoryId: string,
    versionDescriptor: GitVersionDescriptor | undefined,
    path: string,
    contentOnly: boolean = false,
    includeContentMetadata: boolean = false
): string {
    const routeValues: { [name: string]: string } = {
        area: "git",
        project: projectId,
        repositoryId,
        resource: "Items"
    };
    const queryValues: { [name: string]: any } = {
        path,
        download: !contentOnly,
        resolveLfs: true,
        $format: "octetStream",
        "api-version": GIT_ITEMS_API_VERSION
    };

    if (isFeatureFlagEnabled(pageContext, AttachSvgFileFF, false)) {
        queryValues.sanitize = true;
    }

    if (includeContentMetadata) {
        queryValues.includeContentMetadata = true;
    }

    if (versionDescriptor) {
        queryValues["versionDescriptor.version"] = versionDescriptor.version;
        if (versionDescriptor.versionOptions) {
            queryValues["versionDescriptor.versionOptions"] = versionDescriptor.versionOptions;
        }

        if (versionDescriptor.versionType) {
            queryValues["versionDescriptor.versionType"] = versionDescriptor.versionType;
        }
    }
    const routeTemplate = "{project}/_apis/{area}/repositories/{repositoryId}/{resource}";

    return routeUrlFromRouteTemplate(pageContext, routeTemplate, { ...routeValues, ...queryValues });
}
